import {
  UPDATE_DASHBOARD_STATS,
  FETCH_DASHBOARD_STATS_START,
  FETCH_DASHBOARD_STATS_ERROR,
  STOP_IMPERSONATE_USER,
  LOGOUT
} from "../actions/Types";
import Immutable from "seamless-immutable";

const initialState = Immutable({
  statsByYear: {},
  availableYears: [],
  fetchingYears: {},
  initialFetched: false
});

const startFetch = (state, action) => {
  return Immutable.setIn(state, ["fetchingYears", action.year], true);
};

const updateStats = (state, action) => {
  const { year, data, availableYears } = action;
  return state
    .setIn(["statsByYear", year], Immutable(data))
    .setIn(["fetchingYears", year], false)
    .set("availableYears", availableYears || state.availableYears)
    .set("initialFetched", true);
};

const errorFetch = (state, action) => {
  return Immutable.setIn(state, ["fetchingYears", action.year], false);
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DASHBOARD_STATS_START:
      return startFetch(state, action);
    case UPDATE_DASHBOARD_STATS:
      return updateStats(state, action);
    case FETCH_DASHBOARD_STATS_ERROR:
      return errorFetch(state, action);
    case STOP_IMPERSONATE_USER:
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
